(function($){
  'use strict';

  if(!$.gnv){
      $.gnv = new Object();
  };

  $.gnv.rebrandBg = function(el, options){
    var base = this;

    base.$el = $(el);
    base.el = el;

    base.$animatecircle1        = null;
    base.$animatecircle1bis     = null;
    base.$animatecircle2        = null;
    base.$animatecircle2bis     = null;
    base.$animatecircle3        = null;

    base.$circle1               = null;
    base.$circle1bis            = null;
    base.$circle2               = null;
    base.$circle2bis            = null;
    base.$circle3               = null;

    base.semaphoreXSmall         = true;
    base.semaphoreSmall         = true;
    base.semaphoreLarge         = true;
    base.semaphoreXLarge         = true;

    base.circleTopIncrement      = true;

    base.$el.data("gnv.rebrandBg", base);

    base.init = function(){
      base.options = $.extend({},$.gnv.rebrandBg.defaultOptions, options);

      base.$circle1      = $(base.options.circle1);
      base.$circle1bis   = $(base.options.circle1bis);
      base.$circle2      = $(base.options.circle2);
      base.$circle2bis   = $(base.options.circle2bis);
      base.$circle3      = $(base.options.circle3);

      base.$animatecircle1      = $(base.options.animatecircle1);
      base.$animatecircle1bis   = $(base.options.animatecircle1bis);
      base.$animatecircle2      = $(base.options.animatecircle2);
      base.$animatecircle2bis   = $(base.options.animatecircle2bis);
      base.$animatecircle3      = $(base.options.animatecircle3);

    };

    base.changeTop = function(value){
      base.$circle1.attr('cy', value);
      base.$circle1bis.attr('cy', value);
      base.$circle2.attr('cy', value);
      base.$circle2bis.attr('cy', value);
      base.$circle3.attr('cy', value);
      //console.log(value);
    }

    base.changeRadius = function(value, type){
      base.$animatecircle1.attr('to', value + type);
      base.$animatecircle1bis.attr('to', value/5*3 + type);
      base.$animatecircle2.attr('to', value + type);
      base.$animatecircle2bis.attr('to', value/5*2 + type);
      base.$animatecircle3.attr('to', value + type);
      //console.log(value);
    }

    base.resize = function(width){

      var elOffset = $('#page_loading_message_subtitle_js').offset();

      if (width < 550) {
        if(base.semaphoreXSmall) {
          base.changeRadius('4','%');
          base.semaphoreXSmall = false;
          base.semaphoreSmall = true;
          base.semaphoreLarge = true;
          base.semaphoreXLarge = true;
          base.circleTopIncrement = 200;
        }
      } else if (width < 768) {
        if(base.semaphoreSmall) {
          base.changeRadius('6','%');
          base.semaphoreSmall = false;
          base.semaphoreLarge = true;
          base.semaphoreXLarge = true;
          base.semaphoreXSmall = true;
          base.circleTopIncrement = 200;
        }
      } else if (width < 1100) {
        if(base.semaphoreLarge) {
          base.changeRadius('8','%');
          base.semaphoreLarge = false;
          base.semaphoreSmall = true;
          base.semaphoreXLarge = true;
          base.semaphoreXSmall = true;
          base.circleTopIncrement = 250;
        }
      } else {
        if(base.semaphoreXLarge) {
          base.changeRadius('10','%');
          base.semaphoreXLarge = false;
          base.semaphoreLarge = true;
          base.semaphoreSmall = true;
          base.semaphoreXSmall = true;
          base.circleTopIncrement = 250;
        }
      }

      base.changeTop(elOffset.top + base.circleTopIncrement);

    };

    base.init();

    window.resizedCallback.push(base.resize);

  };

  $.gnv.rebrandBg.defaultOptions = {
    circle1        : '#rebrand_bg_maskcircle1',
    circle1bis     : '#rebrand_bg_circle1bis',
    circle2        : '#rebrand_bg_maskcircle2',
    circle2bis     : '#rebrand_bg_circle2bis',
    circle3        : '#rebrand_bg_maskcircle3',
    animatecircle1        : '#animatecircle1',
    animatecircle1bis     : '#animatecircle1bis',
    animatecircle2        : '#animatecircle2',
    animatecircle2bis     : '#animatecircle2bis',
    animatecircle3        : '#animatecircle3'
  };

  $.fn.gnv_rebrandBg = function(options){
    return this.each(function(){
      (new $.gnv.rebrandBg(this, options));
    });
  };

})(jQuery);
